export const Status = ({ color }: { color: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="6"
      viewBox="0 0 32 6"
      fill="none"
    >
      <rect width="32" height="6" rx="2" ry="2" fill={color} />
    </svg>
  );
};
